export default {
  webData: {},
  gradeOptions: ['小学', '初中', '高中', '课外'],
  userinfo: '',
  room_id: '',
  wechat_token: '',
  access_token: '',
  stage_list: '',
  pkType: ''
}
